import { defineMessages } from 'react-intl';

export const scope = 'app.containers.FormikCodeInput';

export default defineMessages({
  codeInputLabel: {
    id: `${scope}.codeInputLabel`,
    defaultMessage: 'Enter digit',
  },
});
